import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const mainStatisticsContainer = style({
  display: 'flex',
  justifyContent: 'space-between',

  ...responsiveStyle({
    mobile: {
      padding: 0,
      flexDirection: 'column',
      gap: space.s20,
    },
    tablet: {
      flexDirection: 'row',
      gap: space.s32,
    },
    desktop: {
      padding: `0 ${space.s20}px`,
    },
  }),
});

export const leftSide = style({
  display: 'grid',
  gridTemplateColumns: 'min-content auto',
  gridAutoRows: 'min-content',

  ...responsiveStyle({
    mobile: {
      gap: space.s12,
    },
    desktop: {
      columnGap: space.s24,
      rowGap: space.s12,
    },
  }),
});

export const avatar = style([
  responsiveStyle({
    mobile: {
      gridRow: '1 / 2',
    },
    desktop: {
      gridRow: '1 / 3',
    },
  }),
]);

export const content = style({
  selectors: {
    [`${leftSide} &`]: {
      display: 'flex',
      flexDirection: 'column',
      gap: space.s12,

      ...responsiveStyle({
        mobile: {
          gridColumn: '1 / 4',
        },
        desktop: {
          gridColumn: '2 / 4',
        },
      }),
    },
  },
});

export const bio = style({
  color: themeVars.container.foreground.secondary,
  ...responsiveStyle({
    mobile: {
      ...typography['bodySm'],
    },
    desktop: {
      ...typography['bodyMd'],
    },
  }),
});
